
import {
  GET_NEWS_SUCCESS,
  GET_NEWS_FAIL,
  ADD_NEWS_SUCCESS,
  ADD_NEWS_FAIL,
  UPDATE_NEWS_SUCCESS,
  UPDATE_NEWS_FAIL,
  DELETE_NEWS_SUCCESS,
  DELETE_NEWS_FAIL,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAIL,
  ADD_COMMENTS_SUCCESS,
  ADD_COMMENTS_FAIL,
  GET_COMMENTS_CYCLE_RENEW_SUCCESS,
  GET_COMMENTS_CYCLE_RENEW_FAIL,
  ADD_COMMENTS_CYCLE_RENEW_SUCCESS,
  ADD_COMMENTS_CYCLE_RENEW_FAIL,

} from "./actionTypes";

const INIT_STATE = {
  news: [],
  comments: [], 
  cyclerenew: [], 
  error: {}, 
};

const news = (state = INIT_STATE, action) => {
  switch (action.type) {
case GET_NEWS_SUCCESS:
  console.log("Data received in success action:", action.payload); // Log the action.payload
  return {
    ...state,
    news: action.payload,
  };

case GET_NEWS_FAIL:
  return {
    ...state,
    error: action.payload,
  };

  case ADD_NEWS_SUCCESS:
    return {
      ...state,
      news: [...state.news, action.payload.data],
    };

  case ADD_NEWS_FAIL:
    return {
      ...state,
      error: action.payload,
    };
      case UPDATE_NEWS_SUCCESS:
      return {
        ...state,
        news: state.news.map(newsItem =>
          newsItem.id === action.payload.data.id
            ? action.payload.data
            : newsItem
        ),
      };

    case UPDATE_NEWS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_NEWS_SUCCESS:
      return {
        ...state,
        news: state.news.filter(newsItem => newsItem.id !== action.payload),
      };

    case DELETE_NEWS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
 case GET_COMMENTS_SUCCESS:
  console.log("Data received in success action:", action.payload); // Log the action.payload
  return {
    ...state,
    news: action.payload,
  };

case GET_COMMENTS_FAIL:
  return {
    ...state,
    error: action.payload,
  };

case ADD_COMMENTS_SUCCESS:
    return {
      ...state,
      news: [...state.news, action.payload.data],
    };

  case ADD_COMMENTS_FAIL:
    return {
      ...state,
      error: action.payload,
    };
  case GET_COMMENTS_CYCLE_RENEW_SUCCESS:
  console.log("Data received in success action:", action.payload); // Log the action.payload
  return {
    ...state,
    cyclerenew: action.payload,
  };

case GET_COMMENTS_CYCLE_RENEW_FAIL:
  return {
    ...state,
    error: action.payload,
  };

case ADD_COMMENTS_CYCLE_RENEW_SUCCESS:
    return {
      ...state,
      cyclerenew: [...state.news, action.payload.data],
    };

  case ADD_COMMENTS_CYCLE_RENEW_FAIL:
    return {
      ...state,
      error: action.payload,
    };

    default:
      return state;
  }
};

export default news;

